import {useEffect} from "react";

const setMetaProperty = (property: string, content: string) => {
    let tag = document.head.querySelector(`meta[property="${property}"]`)
    if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('property', property)
        document.head.appendChild(tag)
    }
    tag.setAttribute('content', content)
}

const useOgMeta = (title?: string, imageUrl?: string) => {
    useEffect(() => {
        if (title && title.length > 0) {
            setMetaProperty('og:title', title)
        }
    }, [title])

    useEffect(() => {
        if (imageUrl && imageUrl.length > 0) {
            // og:image must be an absolute url
            setMetaProperty('og:image', new URL(imageUrl, window.location.origin).href)
        }
    }, [imageUrl])
}

export default useOgMeta
